import { NotificationId } from 'features/notifications/types';
import { call, put, select } from 'redux-saga/effects';
import { selectNotificationsByScope } from 'features/notifications/notificationsSlice';
import { Action } from '@reduxjs/toolkit';
import { closeActionNotifications } from 'features/notifications/thunks/closeActionNotifications';

export function* cleanupBreakoutRoomsNotificationsSaga() {
  const allBreakoutNotifications: NotificationId[] = yield select(
    selectNotificationsByScope,
    'breakout-room'
  );

  const cleanupNotificationsThunk: Action = yield call(
    closeActionNotifications,
    allBreakoutNotifications
  );
  yield put(cleanupNotificationsThunk);
}
